import { push } from "connected-react-router";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { APPLICATION_MODE_RENEW, APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE, ROUTE_PATH } from "../../../app/constants";
import {
  Header,
  Paragraph,
  Button,
  ErrorMark,
  MortgageRegulationContacts,
} from "../../../components/RegularComponents";
import CheckboxForm from "../../../components/CheckBoxForm";
import TopNavigationBar from "../../TopNavigationBar";
import { setMortgageProperty } from "../../../redux/slice/primaryAgencyApplicationSlice";
import { fullName } from "../../../app/utils";
import { 
  currentAgentApplicationSelector,
  currentAgentCachePropertiesSelector
} from "../../../redux/selector/collectorApplicationSelector";
import * as CONST from "../../../app/constants";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { setAgentCacheProperty } from '../../../redux/slice/additionalApplicationsSlice';

const MORTGAGE_APPLICATION_PROPERTY = "principalBrokerDutiesConfirmation";

export const MraRenewalPrincipalBrokerActRegulation = (props) => {
  const { isModal = false, onEditSave = () => {} } = props;
  const dispatch = useDispatch();
  const { agencyApplication }  = useSelector(agencyApplicationSelector);
  const currentBroker = useSelector(currentAgentApplicationSelector);
  const agentCacheProperties = useSelector(currentAgentCachePropertiesSelector);
  
  let checked;
  if(currentBroker?.licencingSubType === CONST.LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION
    || currentBroker?.licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION
    || currentBroker?.licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION
  ) {
    checked = !!agentCacheProperties[CONST.MORTGAGE_PROPERTY_KEYS.BROKER_DUTIES_CONFIRMATION];
  }
  else {
    checked = !!agencyApplication?.businessLicenceData?.[CONST.MORTGAGE_PROPERTY_KEYS.BROKER_DUTIES_CONFIRMATION];
  }

  const [confirmCheck1, setConfirmCheck1] = useState(checked);
  const [confirmCheck2, setConfirmCheck2] = useState(checked);

  const [showValidationError, setShowValidationError] = useState(false);
 
  const principalBrokerPersonData = agencyApplication?.businessLicenceData?.personData
  const currentBrokerPersonData = currentBroker?.businessLicenceData?.personData
 
  const handleNext = () => {
    if (
      !confirmCheck1 ||
      !confirmCheck2
    ) {
      setShowValidationError(true);
      return;
    }

    setShowValidationError(false);
    if(currentBroker?.licencingSubType === CONST.LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION
        || currentBroker?.licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION
        || currentBroker?.licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION
      ) {
        dispatch(setAgentCacheProperty({
          key: MORTGAGE_APPLICATION_PROPERTY,
          value: true
      }));
    }
    else {
      // Set MORTGAGE PROP value 
      dispatch(
        setMortgageProperty({
          key: MORTGAGE_APPLICATION_PROPERTY,
          value: true,
        })
      );
    }
    

    // On to the next item
    dispatch(
      push(
        `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_RENEWAL_BROKER_APPLICATION_REVIEW}`
      )
    );
  };

  const handleModalClose = () => {

    if (
      !confirmCheck1 ||
      !confirmCheck2
    ) {
      setShowValidationError(true);
      return;
    }

    onEditSave();
  };

  let headerText, checkBox1Label, checkBox2Label, errorMessage
  
  if(currentBroker && currentBroker.licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION) {
    headerText = "Mortgage Broker - Act and Regulations Confirmation";
    checkBox1Label = `I, <b>${fullName(principalBrokerPersonData)}</b>, confirm that <b>${fullName(currentBrokerPersonData)}</b> has read and is aware of  
                      <a href="${CONST.MRA_REGULATION_ACT_DOCUMENT_LINK}" target="blank">the contents and requirements of the Mortgage Regulation Act (MRA)</a> and
                      <a href="${CONST.MRA_REGULATION_JUSTICE_LINK}" target="blank"> MRA Regulations</a> <b>and agrees to be bound by its provisions.</b>`
    checkBox2Label = `I, <b>${fullName(principalBrokerPersonData)}</b>, confirm that <b>${fullName(currentBrokerPersonData)}</b> has been in compliance with the Act and its Regulations.</b>`
    errorMessage = `You must confirm ${fullName(currentBrokerPersonData)} has read the Mortgage Regulation Act (MRA) and the MRA regulations in order to have their renewal approved. If you require assistance, contact Business Licensing:`
  }
  else if(currentBroker && currentBroker.licencingSubType === CONST.LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION) {
    headerText = "Associate Mortgage Broker - Act and Regulations Confirmation";
    checkBox1Label = `I, <b>${fullName(principalBrokerPersonData)}</b>, confirm that <b>${fullName(currentBrokerPersonData)}</b> has read and is aware of  
                      <a href="${CONST.MRA_REGULATION_ACT_DOCUMENT_LINK}" target="blank">the contents and requirements of the Mortgage Regulation Act (MRA)</a> and
                      <a href="${CONST.MRA_REGULATION_JUSTICE_LINK}" target="blank"> MRA Regulations</a> <b>and agrees to be bound by its provisions.</b>`
    checkBox2Label = `I, <b>${fullName(principalBrokerPersonData)}</b>, confirm that <b>${fullName(currentBrokerPersonData)}</b> has been in compliance with the Act and its Regulations.</b>`
    errorMessage = `You must confirm ${fullName(currentBrokerPersonData)} has read the Mortgage Regulation Act (MRA) and the MRA regulations in order to have their renewal approved. If you require assistance, contact Business Licensing:`
  }
  else {
    headerText = "Principal Broker - Act and Regulations Confirmation";
    checkBox1Label = `I, <b>${fullName(currentBrokerPersonData)}</b>, have read and am aware of contents and requirements of the 
                      <a href="${CONST.MRA_REGULATION_ACT_DOCUMENT_LINK}" target="blank">Mortgage Regulation Act (MRA)</a> and
                      <a href="${CONST.MRA_REGULATION_JUSTICE_LINK}" target="blank"> MRA Regulations</a> <b>and agree to be bound by their provisions.</b>`
    checkBox2Label = `I, <b>${fullName(currentBrokerPersonData)}</b>, have been in compliance with the Act and its Regulations.</b>`
    errorMessage = `You must confirm you have read the Mortgage Regulation Act (MRA) and the MRA regulations in order to have your renewal approved. If you require assistance, contact Business Licensing:`
  }

  return (
    <>
      <div className={!isModal ? "container" : ""}>
        {!isModal && (
          <>
            <TopNavigationBar 
              {...props} 
              applicationType={APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE} 
              applicationMode={APPLICATION_MODE_RENEW} 
            />
            <div className="row">
              <div className="col-xs-12 col-lg-9">
                <Header
                  style={{ paddingBottom: "20px" }}
                  id="broker-confirmation-header"
                  header={headerText}
                />
              </div>
            </div>
          </>
        )}

        <div className="row">
          <div className="col-lg-1">
            <CheckboxForm
              id="broker-confirmation-checkbox"
              checked={confirmCheck1}
              value={confirmCheck1}
              labelStyle={{ fontWeight: "normal !important" }}
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck1(val);
              }}
            />
          </div>
          <div className="col-lg-11">
            <Paragraph
              style={{ marginLeft: "-20px" }}
              id="broker-confirmation-header"
              text={[checkBox1Label]}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-1">
            <CheckboxForm
              id="broker-confirmation-checkbox"
              checked={confirmCheck2}
              value={confirmCheck2}
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck2(val);
              }}
            />
          </div>
          <div className="col-lg-11">
            <Paragraph
              style={{ marginLeft: "-20px" }}
              id="broker-confirmation-header"
              text={[checkBox2Label]}
            />
          </div>
        </div>

        <div className="row">
          <div
            className={"col-lg-4" + (showValidationError ? " has-error" : "")}
          >
            <Button
              id="complete-mortgage-education-continue-button"
              style={{ margin: "0 10px 10px 0" }}
              buttonType={"regular_primary"}
              text={!isModal ? "Save and next" : "Save and close"}
              onClick={!isModal ? handleNext : handleModalClose}
            />
            {showValidationError && ErrorMark()}
            {showValidationError && 
              <MortgageRegulationContacts 
                message={errorMessage}
              />
            }
          </div>
        </div>
      </div>
    </>
  );
};
